import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    header: {
      marginBottom: '0px !important',

      '.ant-modal-title': {
        fontSize: token.fontSizeXL
      }
    },

    divider: {
      position: 'relative',
      left: `-${token.paddingLG}px`,
      width: `calc(100% + ${token.paddingLG}px * 2)`,
      // Tighter than AntD's default: the rule separates the intro line from the
      // progress, and the default margin left the modal looking half-empty.
      marginBlock: token.marginXS
    },

    stepsContainer: {
      maxHeight: 'min(320px, 40vh)',
      overflowY: 'auto',
      paddingRight: token.paddingXS
    }
  }
})
